import type { HelpFile } from '../../types/help'
import { NewRequestButtonsTestIds } from '../../../testids/NewRequestButtonsTestIds'

export const newRequestButtonsHelp: HelpFile = {
  docPage: '/docs/my-iam/requests',
  texts: {
    [NewRequestButtonsTestIds.btnNewRequest]:
      'Ein oder mehrere Zugriffsprofile für diese oder eine andere Identität über den Zugriffsantrags-Assistenten beantragen.',
    [NewRequestButtonsTestIds.btnNewFgRequest]:
      'Ein Funktionsgruppen-Bündel beantragen — zusammengehörige Zugriffsprofile, die über eine Funktionsgruppe definiert sind.',
  },
}
